import axios from '../config'
import { lessonplay_data } from '../baseURL'
import { LESSONPLAY_TOKEN } from '../../config/url';

export default {
    //获取数据
    getData(type, param) {
        let token = window.localStorage.getItem(LESSONPLAY_TOKEN);
        if (type == "verifyToken") token = param.token;

        let data = {
            type,   // 方法类型(必传)
            param   // 对应参数(必传)
        }
        if (type != "sharer") data.token = token; // 用户token(除两个登录方法外必传)

        return axios({
            url: lessonplay_data,
            method: "POST",
            data
        })
    },
    //分享登陆
    sharerLogin() {
        return this.getData("sharer")
    },
    //验证token
    verifyToken(param) {
        return this.getData("verifyToken", param)
    },
    //注册
    register(param) {
        return this.getData("register", param)
    },
    //获取密保问题
    getProblemList() {
        return this.getData("getProblemList")
    },
    //获取我的密保问题
    getMyProblem() {
        return this.getData("getMyProblem")
    },
    //修改密保
    editSecurity(problemGuid, answer) {
        let param = { problemGuid, answer };
        return this.getData("editSecurity", param)
    },
    //检查密码是否正确
    checkPassword(password) {
        let param = { password };
        return this.getData("checkPassword", param)
    },
    //修改密码
    putPassword(password) {
        let param = { password };
        return this.getData("putPassword", param)
    },
    //修改学生信息
    updateStudent(param) {
        return this.getData("updateStudent", param)
    },
    //获取学生信息
    getStudent(param) {
        return this.getData("getStudent", param)
    },
    //查询学生所有记录
    getStudentRecord() {
        return this.getData("getStudentRecord")
    },
    //获取学生所有班级
    getClassOfUser(platformType) {
        return this.getData("getClassOfUser", { platformType })
    },
    //获取班级信息(包括单元及团队)
    getClassInfo(param) {
        return this.getData("classInfo", param)
    },
    //学生加入班级
    joinClass(param) {
        return this.getData("joinClass", param)
    },
    //搜索组织学校
    searchOrg(param) {
        return this.getData("searchOrg", param)
    },
    //获取班级成绩（完成度）
    getScoreList(param) {
        return this.getData("getScoreList", param)
    },
    //登录
    login(param) {
        return this.getData("login", param)
    },
    //根据邀请码进行查询班级
    classCode(param) {
        return this.getData("classCode", param)
    },
    //查询平台信息
    getPlatformInfo(platformType) {
        return this.getData("getPlatformInfo", { platformType })
    },
    //显示成就
    showAchievement(param) {
        return this.getData("showAchievement", param)
    },
    //获取所有成就
    getAllAchievement() {
        return this.getData("getAllAchievement")
    },
    //获取我的所有队伍
    getMyTeamList(param) {
        return this.getData("getMyTeamList", param)
    },
    //获取我的所有队伍
    getChat(param) {
        return this.getData("getChat", param)
    },
    //用户是否购买教材班
    isBuyTextbookClass(param) {
        return this.getData("isBuyTextbookClass", param)
    },
}